import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import {
  ILandingPageBuilderPayload,
  ILandingPageDesignResponse,
} from 'app/pages/admin/landing-pages-v2/types';
import { useToastError } from 'lib/hooks';

export const createLandingPageDesign = async (
  payload: ILandingPageBuilderPayload
) => {
  const response = await EXPRESS_API.post(
    `/superadmin/landing-page-designs`,
    payload
  );

  return response.data as ILandingPageDesignResponse;
};

export const useCreateLandingPageDesignMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(createLandingPageDesign, {
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGNS',
        exact: false,
      });
      onSuccess && onSuccess();
      successToast({
        title: 'Design has been successfully created!',
      });
    },
    onError: error =>
      showError(
        error || 'An error occured while trying to create the template!'
      ),
  });
};
